import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { browserHistory, withRouter } from 'react-router';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import FlatButton from 'material-ui/FlatButton';
import { SALARY_RANGES } from 'constants/salaryranges.constants';

import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';
import { RenderGhostError } from 'components/shared/RenderError';
import SinNumberFormField from 'components/shared/SinNumberFormField';
import { getPropertyPublic } from 'actions/landlordPropertiesActions';

import validate from '../validate';

import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

import moment from 'moment';
import scrollIntoView from 'scroll-into-view';
import { deepDiver } from 'helpers/utilities';

const style = {
  button: {
    color: 'white',
    float: 'right',
    height: '40px',
  },
  backButton: {
    float: 'left',
    color: AccentColor(),
    height: '40px',
  },
  add_photo: {
    fontSize: '40px',
    color: '#9e9e9e',
    opacity: '0.9',
  },
  dropzone: {
    margin: 'auto !important',
    float: 'none !important',
  },
  dropInComponent: {
    width: '256px',
    margin: 'auto',
  },
};

class WizardFormForthPage extends React.Component {
  componentDidMount() {
    const propertyId = browserHistory.getCurrentLocation().query.property_id;
    this.props.getPropertyPublic(propertyId);
  }
  render() {
    const { handleSubmit, previousPage, isGuarantor } = this.props;
    return (
      <div id="top" style={{ marginTop: '50px' }}>
        <h3
          style={{
            fontSize: '30px',
            marginBottom: '15px',
            fontFamily: 'Circular-Bold',
          }}
        >
          Please provide your personal details below. Don&rsquo;t forget to upload a photo of
          yourself!
        </h3>
        <h4 style={style.details}>
          <b style={style.emphasis}>Important:</b> Your birthday will be used to process a credit
          report. Please make sure it is accurate.
        </h4>
        <form onSubmit={handleSubmit}>
          <div className="row" style={{ marginBottom: '70px' }}>
            <div
              className="col-sm-12"
              style={{ textAlign: 'center', marginTop: '15px', marginBottom: '20px' }}
            >
              <Field
                name="avatar"
                component={ReduxDropzone}
                size={120}
                dontShowFiles
                circle
                fileValidation=".jpeg, .png, .jpg"
              />
            </div>
            <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
              <Field
                name="dob"
                maxDate={moment()
                  .subtract(this.props.minimumApplicantAge || 18, 'years')
                  .toDate()}
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                popperPlacement="top-end"
                component={DatePickerAccessible}
                style={{ marginTop: '15px', fontSize: '14px', width: '100%' }}
                formatDate={formatter.reformatDate}
                autoOk={true}
                textFieldStyle={{ fontSize: '14px' }}
                label="Вirthday"
                variant="outlined"
                validate={[validator.required]}
                errorStyle={{ fontSize: '14px' }}
              />
              <Field name="dob" component={RenderGhostError} />
            </div>
            {isGuarantor && (
              <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
                <Field
                  name="yearly_income"
                  component={OutlinedSelect}
                  hintText={getTranslatedString('yearlyIncome')}
                  label={getTranslatedString('yearlyIncome')}
                  validate={[validator.required]}
                  style={{ fontSize: '14px', textAlign: 'left' }}
                  errorStyle={{ fontSize: '14px' }}
                >
                  {SALARY_RANGES.map((range) => (
                    <MenuItem value={range.integerValue}>{range.primaryText}</MenuItem>
                  ))}
                </Field>
                <Field name="yearly_income" component={RenderGhostError} />
              </div>
            )}

            <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
              <Field
                name={'phoneNumber'}
                type="text"
                label="Phone Number"
                component={ReactPhoneInput}
                validate={[validator.required, validator.validInternationalPhoneNumber]}
                style={{ fontSize: '14px' }}
                errorStyle={{ fontSize: '14px' }}
              />
            </div>
            {this.props.collectLeadSinNumberDuringApplication ? (
              <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '75px' }}>
                <SinNumberFormField />
              </div>
            ) : null}
            {this._renderGenericApplicationQuestions()}
          </div>
          <div id="application_footerbar">
            <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
              <FlatButton
                label="Back"
                type="button"
                className="previous"
                onClick={previousPage}
                backgroundColor="#fff"
                hoverColor="grey"
                style={style.backButton}
              />
              <FlatButton
                label="Next"
                type="submit"
                className="next"
                primary={true}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                style={style.button}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }

  _renderGenericApplicationQuestions = () => {
    const { showAdditionalLeadDetail, property } = this.props;

    if (!showAdditionalLeadDetail) return;

    return (
      <div>
        <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
          <Field
            name="traffic_source"
            component={OutlinedSelect}
            label="How did you hear about us?"
            validate={[validator.required]}
            style={{ fontSize: '14px', width: '100%' }}
          >
            {property &&
              property.traffic_sources &&
              property.traffic_sources.map((trafficSource) => (
                <MenuItem key={`traffic_source_${trafficSource.value}`} value={trafficSource.id}>
                  {trafficSource.traffic_source}
                </MenuItem>
              ))}
          </Field>
        </div>
        {!property.hide_unit_types && (
          <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
            <Field
              name="desired_unit"
              component={OutlinedSelect}
              label="Desired Unit"
              validate={[validator.required]}
              style={{ fontSize: '14px', width: '100%' }}
            >
              {property &&
                property.unit_types &&
                property.unit_types.map((unitType) => (
                  <MenuItem key={`unit_type_${unitType.value}`} value={unitType.value}>
                    {unitType.label}
                  </MenuItem>
                ))}
            </Field>
          </div>
        )}
        <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
          <Field
            name="move_in_date"
            minDate={new Date()}
            component={DatePickerAccessible}
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            dateFormat="yyyy-MM-dd"
            popperPlacement="top-end"
            textFieldStyle={{ width: '100%', fontSize: '14px' }}
            label="Move In Date"
            validate={[validator.required]}
            disableYearSelection
          />
        </div>
      </div>
    );
  };
}

WizardFormForthPage = reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmitFail: (errors) => {
    scrollIntoView(document.getElementById('errorMessage'), {
      time: 500,
      align: {
        top: 0.25,
      },
    });
  },
})(WizardFormForthPage);

WizardFormForthPage = connect(
  (state) => ({
    initialValues: state.tenantApplication.tenantApplication,
    property: state.landlordProperties.property,
    collectLeadSinNumberDuringApplication:
      state.userTypes.userPreferences.collect_lead_sin_number_during_application,
    minimumApplicantAge: state.userTypes.userPreferences.minimum_applicant_age,
    isGuarantor: deepDiver(state.tenantApplication, 'tenantApplication.is_guarantor'),
  }),
  {
    getPropertyPublic,
  }
)(WizardFormForthPage);

export default withRouter(WizardFormForthPage);
